import type { SVGProps } from "react";
const SvgArrowRight02Sharp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M15.833 10h-12.5M12.5 5.833l3.577 3.578c.278.277.417.416.417.589 0 .172-.139.311-.417.59L12.5 14.166"
    />
  </svg>
);
export default SvgArrowRight02Sharp;
